export default "__VITE_ASSET__a5ad0662__"